import { categories } from '../utils';

const {
  FENCE, HVAC, BATHLINERS, WINDOW,
  CABINET_MAKEOVER, GENERATOR, INTERIOR_SHUTTER,
  SOLAR, WATER_TREATMENT, SHOWER_DOOR
} = categories;

export const serviceIdentifierToProgramCatogoryMap = new Map([
  [FENCE, '8fa995a0c'],
  [HVAC, 'c16fbb4b7'],
  [BATHLINERS, 'f939dd56a'],
  [WINDOW, 'e57e696e1'],
  [CABINET_MAKEOVER, 'bf24dfc4c'],
  [GENERATOR, 'efecec25e'],
  [INTERIOR_SHUTTER, '24a343ba1'],
  [SOLAR, '3e382af82'],
  [WATER_TREATMENT, '879700ce6'],
  [SHOWER_DOOR, 'a68d60194']
]);